import { render, staticRenderFns } from "./EmployeeLeaves.vue?vue&type=template&id=ffc5831c&scoped=true"
import script from "./EmployeeLeaves.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc5831c",
  null
  
)

export default component.exports